import * as filterEnum from "enums/filterEnum";
import { Plant } from "models";

export const Text = filterEnum.Text<"plants", Plant>;
export const Dropdown = filterEnum.Dropdown<"plants", Plant>;

/**
 * Returns a multi-select dropdown field labeled "Plant".
 *
 * @function PlantSectorSearchField
 * @param {string[]} sectorIds - Sector IDs used to fetch plants for selected sectors.
 * @returns {Dropdown} A configured dropdown component with a list of plant options.
 */

export const PlantSectorSearchField = (sectorIds: string[]) =>
	Dropdown({
		field: "plants",
		multiple: true,
		label: "Plant",
		getter: async ({ api: _api }) => {
			const api = _api();
			if (!sectorIds || sectorIds.length === 0) return [];

		const plantRequests = sectorIds.map((sectorID) =>
			api.Plants({ sectorID }).then((plants: any[]) =>
				plants.map((plant) => ({ ...plant, sectorId: sectorID }))
			)
		);
		const plantsArray = await Promise.all(plantRequests);

		return plantsArray.flat();
		},
	});

/**
 * Returns a multi-select dropdown filtered by containment sector type.
 * Each sectorTypeId encodes both the sector and the containment type,
 * so only plants associated with the selected containment type are returned.
 *
 * @param sectorTypeIds - ContainmentSectorType IDs from the form's sectorTypes field.
 * @param sectorIdBySectorTypeId - Map from sectorTypeId to its parent sectorId,
 *   used to annotate each plant with its sector for per-sector validation.
 */
export const PlantSectorTypeSearchField = (
	sectorTypeIds: string[],
	sectorIdBySectorTypeId: Record<string, string>
) =>
	Dropdown({
		field: "plants",
		multiple: true,
		label: "Plant",
		getter: async ({ api: _api }) => {
			const api = _api();
			if (!sectorTypeIds || sectorTypeIds.length === 0) return [];

			const plantRequests = sectorTypeIds.map((sectorTypeID) =>
				api.Plants({ sectorTypeID }).then((plants: any[]) =>
					plants.map((plant) => ({
						...plant,
						sectorId: sectorIdBySectorTypeId[sectorTypeID] ?? "",
					}))
				)
			);
			const plantsArray = await Promise.all(plantRequests);

			return plantsArray.flat();
		},
	});

export const PlantStaticField = () =>
	Dropdown({
		field: "plants",
		multiple: true,
		label: "Plants",
		getter: async () => [],
	});
